<template>
    <div class="view view--users">
        <div class="is-flex justify-content-end align-items-center">
            <btn
                type="default"
                v-html="__('Export report')"
                v-on:click="getUsersReport"
            />
        </div>
        <data-table
            class="has-margin-b45"
            v-bind:data="tableData"
            v-on:sort="sortDataTable"
        ></data-table>

        <btn
            class="is-success"
            type="default"
            v-html="__('+ Add user')"
            v-on:click="showAddModal"
        ></btn>

        <modal
            class="is-narrow"
            v-bind:title="__('Add user')"
            v-bind:is-open="isOpenAddModal"
            v-on:close-modal="isOpenAddModal = false"
            v-bind:slot-props="errors"
        >
            <template v-slot:body>
                <div class="has-margin-b30">
                    <control
                        name="nameAddControl"
                        type="text"
                        v-bind:label="__('Name')"
                        v-model="addedUser.name"
                    />
                    <div
                        class="has-text-danger has-margin-b10"
                        v-if="errors.name != null"
                    >
                        {{ errors.name[0] }}
                    </div>
                </div>
                <div class="has-margin-b30">
                    <control
                        name="emailAddControl"
                        type="text"
                        v-bind:label="__('Email')"
                        v-model="addedUser.email"
                    />
                    <div
                        class="has-text-danger has-margin-b10"
                        v-if="errors.email != null"
                    >
                        {{ errors.email[0] }}
                    </div>
                </div>
                <div class="has-margin-b30">
                    <control
                        name="roleAddControl"
                        type="select"
                        v-bind:label="__('Role')"
                        v-bind:options="[
                            { label: 'Admin', value: 1 },
                            { label: 'Editor', value: 2 }
                        ]"
                        v-model="addedUser.role"
                    />
                    <div
                        class="has-text-danger has-margin-b10"
                        v-if="errors.role != null"
                    >
                        {{ errors.role[0] }}
                    </div>
                </div>
                <div class="has-margin-b30">
                    <control
                        name="passwordAddControl"
                        type="password"
                        v-bind:label="__('Password')"
                        v-model="addedUser.password"
                    />
                    <div
                        class="has-text-danger has-margin-b10"
                        v-if="errors.password != null"
                    >
                        {{ errors.password[0] }}
                    </div>
                </div>
                <div class="has-margin-b30">
                    <control
                        name="passwordAddConfirmationControl"
                        type="password"
                        v-bind:label="__('Confirm password')"
                        v-model="addedUser.passwordConfirmation"
                    />
                    <div
                        class="has-text-danger has-margin-b10"
                        v-if="errors.passwordConfirmation != null"
                    >
                        {{ errors.passwordConfirmation[0] }}
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <btn
                    class="is-block is-success"
                    type="default"
                    v-html="__('Save')"
                    v-on:click="createUser"
                ></btn>
            </template>
        </modal>

        <modal
            class="is-narrow"
            v-bind:title="__('Edit user')"
            v-bind:is-open="isOpenEditModal"
            v-on:close-modal="isOpenEditModal = false"
            v-bind:slot-props="errors"
        >
            <template v-slot:body>
                <div v-if="editedUser.roleName !== 'User'">
                    <div class="has-margin-b30">
                        <control
                            name="nameEditControl"
                            type="text"
                            v-bind:label="__('Name')"
                            v-model="editedUser.name"
                        />
                        <div
                            class="has-text-danger has-margin-b10"
                            v-if="errors.name != null"
                        >
                            {{ errors.name[0] }}
                        </div>
                    </div>
                    <div class="has-margin-b30">
                        <control
                            name="emailEditControl"
                            type="text"
                            v-bind:label="__('Email')"
                            v-model="editedUser.email"
                        />
                        <div
                            class="has-text-danger has-margin-b10"
                            v-if="errors.email != null"
                        >
                            {{ errors.email[0] }}
                        </div>
                    </div>
                    <div class="has-margin-b30">
                        <control
                            name="roleEditControl"
                            type="select"
                            v-bind:label="__('Role')"
                            v-bind:options="[
                                { label: 'Admin', value: 1 },
                                { label: 'Editor', value: 2 }
                            ]"
                            v-model="editedUser.role"
                        />
                        <div
                            class="has-text-danger has-margin-b10"
                            v-if="errors.role != null"
                        >
                            {{ errors.role[0] }}
                        </div>
                    </div>
                    <p class="has-margin-b15">
                        <strong v-html="__('Change password')"></strong>
                    </p>
                    <div class="has-margin-b30">
                        <control
                            name="passwordEditControl"
                            type="password"
                            v-bind:label="__('Password')"
                            v-model="editedUser.password"
                        />
                        <div
                            class="has-text-danger has-margin-b10"
                            v-if="errors.password != null"
                        >
                            {{ errors.password[0] }}
                        </div>
                    </div>
                    <div class="has-margin-b30">
                        <control
                            name="passwordEditConfirmationControl"
                            type="password"
                            v-bind:label="__('Confirm password')"
                            v-model="editedUser.passwordConfirmation"
                        />
                        <div
                            class="has-text-danger has-margin-b10"
                            v-if="errors.passwordConfirmation != null"
                        >
                            {{ errors.passwordConfirmation[0] }}
                        </div>
                    </div>
                </div>
                <div v-if="editedUser.roleName === 'User'">
                    <div class="has-margin-b30">
                        <control
                            name="referralIdEditControl"
                            type="text"
                            v-bind:label="__('Referral ID')"
                            v-model="editedUser.referralId"
                        />
                        <div
                            class="has-text-danger has-margin-b10"
                            v-if="errors.referral_id != null"
                        >
                            {{ errors.referral_id[0] }}
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <btn
                    class="is-block is-success"
                    type="default"
                    v-html="__('Save')"
                    v-on:click="update"
                ></btn>
            </template>
        </modal>

        <modal
            class="is-narrow"
            v-bind:title="__('Are you sure?')"
            v-bind:is-open="isOpenDeleteModal"
            v-on:close-modal="isOpenDeleteModal = false"
        >
            <template v-slot:body>
                <p
                    class="has-text-center"
                    v-html="
                        __(
                            'Are you sure you want to delete this user?<br />This action cannot be undone.'
                        )
                    "
                ></p>
            </template>
            <template v-slot:footer>
                <div class="has-padding-t10">
                    <div class="columns">
                        <div class="column">
                            <btn
                                class="is-block"
                                type="cancel"
                                v-html="__('Cancel')"
                                v-on:click="isOpenDeleteModal = false"
                            >
                            </btn>
                        </div>
                        <div class="column">
                            <btn
                                class="is-block"
                                type="error"
                                v-html="__('Delete')"
                                v-on:click="deleteUser"
                            >
                            </btn>
                        </div>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import download from 'downloadjs';
import ErrorMessageService from '../../services/ErrorMessageService';
import MessageHandler from '../../messageHandler';
import PriceService from '../../services/PriceService';
import store from '../../store';
import UserReportRepository from '../../repositories/UserReportRepository';
import UserRepository from '../../repositories/UserRepository';
import { Btn } from '@teamfurther/cinderblock';
import { Control } from '@teamfurther/cinderblock';
import { DataTable } from '@teamfurther/cinderblock';
import { Modal } from '@teamfurther/cinderblock';

export default {
    components: {
        Btn,
        Control,
        DataTable,
        Modal
    },
    created: function() {
        this.userRepository = new UserRepository();
        this.errorMessageService = new ErrorMessageService();
    },
    data: function() {
        return {
            addedUser: {
                email: '',
                name: '',
                password: '',
                passwordConfirmation: '',
                role: null
            },
            deletingId: null,
            editedUser: {
                id: null,
                email: '',
                name: '',
                password: '',
                passwordConfirmation: '',
                role: null,
                roleName: '',
                referralId: ''
            },
            errors: {},
            isOpenAddModal: false,
            isOpenDeleteModal: false,
            isOpenEditModal: false,
            tableData: {
                columnNames: {
                    name: this.__('Name'),
                    referralId: this.__('Referral ID'),
                    roleName: this.__('Role'),
                    invitedUsersCount: this.__('Sign ups by referral ID'),
                    totalAmountCollected: this.__('Total amount collected'),
                    isCelebrity: this.__('Is celebrity')
                },
                items: [],
                sortableColumns: ['name', 'roleName', 'isCelebrity']
            },
            users: [],
            userRepository: null,
            userReportRepository: new UserReportRepository(),
            errorMessageService: null,
            priceService: new PriceService()
        };
    },
    methods: {
        createUser: async function() {
            try {
                await this.userRepository.createUser(
                    this.addedUser.name,
                    this.addedUser.email,
                    this.addedUser.password,
                    this.addedUser.passwordConfirmation,
                    this.addedUser.role
                );
                await this.getUsers();

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('User was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                this.isOpenAddModal = false;
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        deleteUser: async function() {
            try {
                await this.userRepository.deleteUser(this.deletingId);

                await this.getUsers();

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('User was successfully deleted.'),
                        this.__('Success.'),
                        'success'
                    )
                );
            } catch (error) {
            } finally {
                this.isOpenDeleteModal = false;
            }
        },
        getUsers: async function(sort = '') {
            try {
                this.users = await this.userRepository.getUsers(sort);

                let items = [];
                this.users.forEach(user => {
                    items.push(this.transformUserData(user));
                });
                this.$set(this.tableData, 'items', items);

                this.$nextTick(() => this.initUpdateCelebrityAction());
            } catch (error) {}
        },
        getUsersReport: async function() {
            const data = await this.userReportRepository.getUserReport();

            download(data, 'user-export.xls', 'application/vnd.ms-excel');
        },
        showAddModal: function() {
            this.addeduser = {
                email: '',
                name: '',
                password: '',
                passwordConfirmation: '',
                role: null
            };

            this.isOpenAddModal = true;
        },
        showDeleteModal: function(data) {
            this.deletingId = data.id;
            this.isOpenDeleteModal = true;
        },
        showEditModal: function(data) {
            this.editedUser = {
                id: data.id,
                email: data.email,
                name: data.name,
                password: '',
                passwordConfirmation: '',
                role: data.role,
                roleName: data.roleName,
                referralId: data.referralId
            };

            this.isOpenEditModal = true;
        },
        transformUserData: function(user) {
            let actions = [
                {
                    method: 'showEditModal',
                    title: this.__('Edit')
                }
            ];

            if (
                store.state.user.role.name === 'admin' &&
                user.role.name !== 'user'
            ) {
                actions.push({
                    class: 'is-red',
                    method: 'showDeleteModal',
                    title: this.__('Delete')
                });
            }

            return {
                values: {
                    id: user.id,
                    email: user.email,
                    name: user.name,
                    referralId: user.referral_id,
                    role: user.role.id,
                    roleName: user.role.display_name,
                    invitedUsersCount: user.invited_users.length,
                    totalAmountCollected: this.priceService.getFormattedPrice(
                        user.total_amount_collected
                    ),
                    isCelebrity: user.is_celebrity
                        ? '<input type="checkbox" class="js-is-celebrity" data-id="' +
                          user.id +
                          '" data-name="' +
                          user.name +
                          '" data-email="' +
                          user.email +
                          '" checked />'
                        : '<input type="checkbox" class="js-is-celebrity" data-id="' +
                          user.id +
                          '" data-name="' +
                          user.name +
                          '" data-email="' +
                          user.email +
                          '" />'
                },
                actions: actions
            };
        },
        sortDataTable: function(sortByColumn) {
            if (
                this.tableData.sortableColumns.includes(
                    sortByColumn.replace('-', '')
                )
            ) {
                this.getUsers(sortByColumn);
            }
        },
        update: function() {
            if (this.editedUser.roleName === 'User') {
                this.updateUser();
                return;
            }

            this.updateNotUser();
        },
        updateUser: async function() {
            try {
                await this.userRepository.updateUserReferralId(
                    this.editedUser.id,
                    this.editedUser.name,
                    this.editedUser.email,
                    this.editedUser.referralId
                );

                await this.getUsers();

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('User was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                this.isOpenEditModal = false;
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        updateNotUser: async function() {
            try {
                await this.userRepository.updateUser(
                    this.editedUser.id,
                    this.editedUser.name,
                    this.editedUser.email,
                    this.editedUser.password,
                    this.editedUser.passwordConfirmation,
                    this.editedUser.role
                );

                await this.getUsers();

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('User was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                this.isOpenEditModal = false;
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        updateUserIsCelebrity: async function(e) {
            const checkbox = e.target;
            const id = checkbox.getAttribute('data-id');
            const name = checkbox.getAttribute('data-name');
            const email = checkbox.getAttribute('data-email');
            let isCelebrity = 0;

            if (checkbox.checked) {
                isCelebrity = 1;
            }

            try {
                await this.userRepository.updateUserIsCelebrity(
                    id,
                    name,
                    email,
                    isCelebrity
                );

                await this.getUsers();

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('User was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        initUpdateCelebrityAction: function() {
            const vue = this;

            this.$el
                .querySelectorAll('.js-is-celebrity')
                .forEach(function(checkbox) {
                    checkbox.removeEventListener(
                        'click',
                        vue.updateUserIsCelebrity
                    );
                    checkbox.addEventListener(
                        'click',
                        vue.updateUserIsCelebrity
                    );
                });
        }
    },
    mounted: function() {
        this.getUsers();
    }
};
</script>
